import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS, apiS_fileDownload } from "./api-base"
import { getESGReqHeader } from "./tool-service";

//資料登入清單
export const getDataRegisterList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010202'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010202")}`, method: 'post', data: ReqBody })
}

//取得公司資料
export const getCompanyData = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010101")}`, method: 'post', data: ReqBody })
}

//更新公司資料
export const updateCompanyData = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010102")}`, method: 'post', data: ReqBody })
}

//更新公司資料
export const F2010102Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010102",true)}`, method: 'post', data: ReqBody })
}

//資料登入下載 download File responseType:'blob' //另外處理檔案部分
export const downloadDataRegister = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010203'),
        ReqBody: reqBody
    }
    return await apiS_fileDownload({ url: `/${getTxtIdMapperPath("F1010203")}`, method: 'post', data: ReqBody,responseType:'blob' },false)
}

//資料登入刪除
export const deleteDataRegister = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010204'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010204")}`, method: 'post', data: ReqBody })
}


//資料登入上傳 f1010205
export const createDataRegister= async (formData) => {
    return await apiS({ url: `/${getTxtIdMapperPath("F1010205")}`, method: 'post', data: formData },false,false)
}

//資料登入上傳 統一檢核
export const F1010205Before= async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010205'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010205",true)}`, method: 'post', data: ReqBody })
}

// 下載授權書
export const downloadAuthorizationLetter = async (reqBody = {}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010104'),
        ReqBody: reqBody
    }
    return await apiS(
        { url: `/${getTxtIdMapperPath("F2010104")}`, method: 'post', data: ReqBody, responseType: 'text' },
        false,
        true
    )
}

export const updateComEffectiveType = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F2010103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F2010103")}`, method: 'post', data: ReqBody })
}



